export const Aurora = ({ variant = "hero" }) => {
  if (variant === "hero") {
    return (
      <>
        <div
          className="aurora-blur anim-float"
          style={{
            top: "-10%",
            left: "10%",
            width: "600px",
            height: "600px",
            background: "radial-gradient(closest-side, rgba(59,130,246,0.5), transparent)",
          }}
        />
        <div
          className="aurora-blur anim-float"
          style={{
            top: "20%",
            right: "-5%",
            width: "500px",
            height: "500px",
            background: "radial-gradient(closest-side, rgba(168,85,247,0.45), transparent)",
            animationDelay: "-6s",
          }}
        />
        <div
          className="aurora-blur anim-float"
          style={{
            bottom: "-15%",
            left: "30%",
            width: "700px",
            height: "500px",
            background: "radial-gradient(closest-side, rgba(236,72,153,0.35), transparent)",
            animationDelay: "-3s",
          }}
        />
      </>
    );
  }
  return (
    <div
      className="aurora-blur"
      style={{
        top: "-20%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "700px",
        height: "300px",
        background: "radial-gradient(closest-side, rgba(59,130,246,0.35), transparent)",
      }}
    />
  );
};

export const YDecor = ({ className = "" }) => (
  <span className={`y-decor ${className}`}>Y</span>
);
